import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, withLatestFrom } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { PickId } from '../../../core/picks/pick-id';
import { PickOddsState } from '../../../core/picks/pick-models';
import BetslipPickActions from '../../picks/actions';
import { isPickLocked } from '../../picks/services/linear-betslip-pick.utils';
import { betslipTypeStateSelector } from '../../types/selectors';
import BetslipErrorsActions from '../actions';
import { selectPicksWithAllErrors } from '../selectors';
import { isPickStatusOddsChanged } from '../services/utils/betslip-errors-utils';

@Injectable()
export default class LinearDigitalAcceptChangesEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
    ) {}

    handleAcceptEffectLinear$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipErrorsActions.linearAcceptBetslipChanges),
            withLatestFrom(this.store.select(selectPicksWithAllErrors), this.store.select(betslipTypeStateSelector)),
            switchMap(([_, state, types]) => {
                const toRemove: PickId[] = [];
                const toLock: PickId[] = [];
                const toUnlock: PickId[] = [];
                const toUpdate: PickId[] = [];

                for (const pickWithErrors of state) {
                    if (pickWithErrors.pick.oddsState === PickOddsState.Closed) {
                        toRemove.push(pickWithErrors.pick.id);
                        continue;
                    }

                    const isLocked = isPickLocked(pickWithErrors.pick.id, types);

                    if (!isLocked && pickWithErrors.pick.oddsState === PickOddsState.Locked) {
                        toLock.push(pickWithErrors.pick.id);
                        continue;
                    }

                    if (isLocked && pickWithErrors.pick.oddsState === PickOddsState.Open) {
                        toUnlock.push(pickWithErrors.pick.id);
                        continue;
                    }

                    if (pickWithErrors.errors.some(isPickStatusOddsChanged)) {
                        toUpdate.push(pickWithErrors.pick.id);
                    }
                }

                return [
                    BetslipPickActions.acceptCurrentPrice({ pickIds: toUpdate, isManuallyAccepted: true }),
                    BetslipPickActions.changeLockState({ pickIds: toLock, isLocked: true }),
                    BetslipPickActions.changeLockState({ pickIds: toUnlock, isLocked: false }),
                    BetslipPickActions.requestRemoveMultiplePicks({ pickIds: toRemove }),
                    BetslipPickActions.requestRemovePicksFromGroup({ pickIds: toRemove }),
                ];
            }),
        );
    });
}
